// removed by extract-text-webpack-plugin
module.exports = {"ContactLink__wrapper":"src-components-header----contact-link-module---ContactLink__wrapper---2lc9b"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/contact-link.module.scss
// module id = 214
// module chunks = 114276838955818 184470312924441